import { Component, OnInit } from '@angular/core';
import { TestBed } from '@angular/core/testing';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Group, GroupProduct, GroupProductUpdate, GroupRascunho, GroupUpdate, ProdutoRascunho } from 'src/app/models/group';
import { GroupService } from 'src/app/services/group/group.service';
import { ProductsGroupService } from 'src/app/services/group/products-group.service';
import { ProdutoService } from 'src/app/services/produto.service';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { LocalStoreKeys } from 'src/app/shared/helpers/localstorage/local-store';

@Component({
  selector: 'app-grupo-detalhe',
  templateUrl: './grupo-detalhe.component.html',
  styleUrls: ['./grupo-detalhe.component.css']
})
export class GrupoDetalheComponent implements OnInit {

  public group: Group;
  public productsByGroup: Array<GroupProduct>;
  public newGroupName;
  public newGroupDescription;
  public updatRequest: GroupUpdate;
  public updateGroupProduct: GroupProductUpdate;
  public currentUser;
  private cedenteId;
  public standardPeriodType: string;
  public valorBeneficio: number;
  public selectedItem: GroupProduct;
  inInvalidMaxValue = false;
  messageMaxValueInvalid = 'O valor mínimo deve ser menor ou igual ao valor máximo do produto'

  constructor(private router: Router, private productsGroupService: ProductsGroupService, private modalService: NgbModal,
              private alertService: NewAlertService, private groupsService: GroupService) {
    this.group = JSON.parse(sessionStorage.getItem('Grupo'));
    this.currentUser = JSON.parse(localStorage.getItem(LocalStoreKeys.currentUser));
    this.cedenteId = parseInt(sessionStorage.getItem('cedenteId'));
  }

  ngOnInit() {
    this.newGroupName = this.group.name;
    this.newGroupDescription = this.group.description;


    this.callProductsOfGroup();
  }

  callProductsOfGroup() {
      this.productsGroupService.getGroupsByGroup(this.group.guidID, this.cedenteId).subscribe(response => {
          if (response.status === 1) {
              this.productsByGroup = response.result.sort((a,b)=> (a.productCategory > b.productCategory) ? -1 : (a.value > b.value) ? -1 : 1);
          } else {
            this.alertService.error(response.message);
        }
      }, error => {
        this.alertService.error('Ocorreu um erro ao listar os produtos do grupo, tente novamente');
    });
  }

  callUpdateGroup(request: GroupUpdate) {
      this.groupsService.updateGroup(request, this.group.guidID).subscribe(response => {
          if (response.status === 1) {
            this.router.navigate(['portal/grupos/list']);
          } else {
              this.alertService.error(response.message);
          }
      }, error => {
          this.alertService.error('Ocorreu um erro ao alterar o grupo, tente novamente');
      });
  }

  visualizar() {
    this.router.navigate(['portal/grupos/list-collaborator']);
  }

  adicionar() {
    this.router.navigate(['portal/grupos/collaborator']);
  }

  novo() {
    this.router.navigate(['portal/colaborador/create']);
  }

  back() {
    this.router.navigate(['portal/grupos/list']);
  }

  editarGrupo(content: any, dados: any) {
    this.modalService.open(content, { centered: true, size: 'xl' });
  }

  editarProdutosGrupo(content: any, dados: any) {
    this.inInvalidMaxValue = false;
    this.selectedItem = dados;
    this.valorBeneficio = this.selectedItem.value;
    if (this.selectedItem.standardPeriodCard === 1) {
      this.standardPeriodType = 'mensal';
    } else if (this.selectedItem.standardPeriodCard === 2) {
      this.standardPeriodType = 'diario';
    }

    this.modalService.open(content, { centered: true, size: 'xl' });
  }

  public formatValue(value, type) {
    let str = '';

    if (type === 'date') {
      if (isNaN((new Date(value)).getHours())) {
        str = value;
      } else {
        str = new Date(value).toLocaleString('pt-BR');
      }
    } else if (type === 'money') {
      str = new Intl.NumberFormat('pt', { style: 'currency', currency: 'BRL' }).format(value);
    } else {
      return value;
    }

    return str;
  }

  public editarCesta() {
    const produtos = [];
    this.productsByGroup.forEach(item => {
      produtos.push(new ProdutoRascunho(item.productID, item.productGuid, item.standardPeriodCard, item.value.toString(), item.productMaxValue, '', '', item.productName, '', item.productCategory));
    });
    const grupo = new GroupRascunho(this.group.name, this.group.description);
    grupo.id = this.group.id;
    grupo.guid = this.group.guidID;
    grupo.products = produtos;
    grupo.isEdicao = true;
    this.groupsService.setRascunho(grupo);
    this.router.navigate(['portal/grupos/beneficios']);
  }

  updateProduct() {
    this.selectedItem.value = this.valorBeneficio;
    if (this.standardPeriodType === 'mensal') {
      this.selectedItem.standardPeriodCard = 1;
    } else if (this.standardPeriodType === 'diario') {
      this.selectedItem.standardPeriodCard = 2;
    }
    /*if(this.selectedItem.value > this.selectedItem.productMaxValue && this.selectedItem.productCategory != 2){
        this.inInvalidMaxValue = true;
        return;
    }*/
    this.productsByGroup.forEach(element => {
      if (element.productID === this.selectedItem.productID) {
        element = this.selectedItem;
      }
    });

    this.productsByGroup.sort((a,b)=> (a.productCategory > b.productCategory) ? -1 : (a.value > b.value) ? -1 : 1);

    this.updateGroupProduct = {products: this.productsByGroup, groupGuid: this.group.guidID, managerGuid: this.currentUser.token.userReferenceId};



    /* Chamada da API UPDATE PRODUCTS */
    this.productsGroupService.updateProducts(this.updateGroupProduct).subscribe(response => {

      if (response.status === 1) {
        this.alertService.success('Produtos atualizados!');
      } else {
          this.alertService.error(response.message);
      }
      }, error => {
        this.alertService.error('Ocorreu um erro ao alterar o produto, tente novamente');
      });

      /*  */
    this.closeModal();
  }

  next() {

    /*  */


    if (this.newGroupName) {
        this.updatRequest = {
            active: true,
            assignorGuid: this.currentUser.token.assignorGuid,
            managerGuid: this.currentUser.token.userReferenceId,
            description: this.newGroupDescription,
            name: this.newGroupName
        };

        this.callUpdateGroup(this.updatRequest);

        this.closeModal();
    } else {
        this.alertService.error('O nome do grupo é obrigatório');
    }
  }

  closeModal() {
    const element = document.getElementById('buttonCloseModal') as HTMLElement;
    element.click();
  }

}
